import {changeContents, chatListSetting, getChattingItemsObj, getProfileRoomType} from "./item.js";
import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {getNoData} from "../../items/index.js";
import Widget from "../widget.js";
import {chatClickEvent} from "./event.js";
import u from "../../../../util/index.js";

export class ChatWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData() {

        /*채팅 리스트 api 호출부*/
        const inputData = {
            ...this.$props.pageData,
            USER_ID: _USER_ID,
            USE_INTT_ID: _USE_INTT_ID,
            SRCH_WORD: "",
        };

        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return {
            recordData: data[this.$props.RECORD]
        };
    }

    async render() {
        $(this.$target).empty()
        $(this.$target).drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('chat'),
            callback: {
                scroll: () => {
                    this.setup.bind(this)({
                        isDataDrivenRendering: true,
                        isScrolling : true,
                    })                },
                item: getChattingItemsObj,
                final: this.mounted.bind(this)
            }
        })
    }


    mounted() {
        super.mounted();

        if ($(this.$target).find('li')[0].classList.contains('widget-null-wrap')) return;

        //왜 들어간거지? 거래소 히스토리 확인 필요
        // $(this.$target).find('li').each((index, item) => {
        //     updateDataOnChattingItem($(item), this.$props.data.LIST_REC[index])
        // })
        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()
    }

    setEvent() {
        $(this.$target).off('click').on('click', chatClickEvent)
    }

}
